import React from 'react';
import type { FC } from 'react';
import isUnicodeSupported from 'is-unicode-supported';
import { Text } from '../components/Text.js';

export const SuccessIcon: FC = () => {
  return <Text>{isUnicodeSupported() ? '✔' : '√'}</Text>;
};
